import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Table, Spinner } from 'react-bootstrap'
import { LeftArrow, CloudDownload } from 'assets/icons/components/index'
import { setMainContent } from 'actions'
import moment from 'moment'
import { toast } from 'components/common/Toast'
import ReactPaginate from 'react-paginate'
import { TransactionServices } from 'services'
import { LoadingOverlay } from 'components//common/index'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import NumberFormat from 'react-number-format'
import { DownloadLink } from './style'

const TransactionHistory = (props) => {
  const { t } = useTranslation('live', { i18n })
  const { dispatch } = props
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(15)
  const [total, setTotal] = useState(0)
  const [history, setHistory] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const back = () => {
    dispatch(setMainContent('dashboard'))
  }

  useEffect(() => {
    getTransactionHistory(page)
  }, [page])

  const getTransactionHistory = async (page = 1) => {
    setIsLoading(true)
    const { data, error } = await TransactionServices.getTransactions({ page, perPage})
    if (error) {
      toast.error(error.message)
    }
    if (data) {
      setHistory(data.transactions)
      setTotal(data.total)
    }
    setIsLoading(false)
  }

  const handlePageChange = (page) => {
    setPage(page?.selected + 1)
  }

  const handleDownload = async (id) => {
    const { data, filename} = await TransactionServices.downloadInvoice(id)

    if (data) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement("a");
      link.href = url
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
    }
  }

  return (
    <div className='main-content__payment-history'>
      <div className='payment-history__container'>
        <div className='container__label'>
          {t('Transaction history')}
        </div>
        {isLoading && <LoadingOverlay />}
        <Table striped bordered hover responsive className='container__table'>
          <thead>
            <tr>
              <th>{t('Transaction #')}</th>
              <th>{t('Service')}</th>
              <th>{t('Date')}</th>
              <th>{t('Status')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {history.map((data, idx) => (
              <tr key={idx}>
                <td>
                  {data?.id}
                </td>
                <td>
                  {t(data.service)}
                </td>
                <td>
                  {moment(data?.created_at).format('MM/DD/YYYY h:mm')}
                </td>
                <td>
                  {data.withdraw ? t(data.withdraw.status) : t('Completed')}
                </td>
                { data.type === 'withdraw' ?
                  <>
                    <td>
                      {t('Amount:')} <span className="__text-success"><NumberFormat value={data?.withdraw?.amount * data?.withdraw?.rate} 
                                      displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale="2" /></span> <br/>
                      {data?.withdraw?.method}: {data?.withdraw?.address}
                      <DownloadLink onClick={ () => handleDownload(data?.id)}>
                        <CloudDownload /> {t('Download invoice')}
                      </DownloadLink>
                    </td>
                  </>
                  :
                  data.type === 'refund' ?
                  <>
                    <td>
                      {t('Balance:')} { data?.balance } <span className="__text-success"> + { data?.amount }</span>
                    </td>
                  </>
                  :
                  <>
                    <td>
                      {t('Balance:')} { data?.balance } 
                      { (data?.type === 'received' || data?.service === 'Purchase' || data?.type === 'bonus') && (<span className="__text-success"> + { data?.amount }</span>) }
                      { (data?.type === 'purchased' && data?.service !== 'Purchase') && (<span className="__text-danger"> - { data?.amount }</span>) }
                    </td>
                  </>
                }
              </tr>
            ))}
          </tbody>
        </Table>
        <div className='container__pagination'>
          <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            pageCount={Math.ceil(total / perPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={handlePageChange}
            containerClassName={'pagination'}
            subContainerClassName={'page-item'}
            activeClassName={'page-item active'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            pageClassNam={'page-item'}
            pageLinkClassName={'page-link'}
          />
        </div>
      </div>
    </div>
  )
}

export default connect(null)(TransactionHistory)
